import { useState, useLayoutEffect } from 'react'


const useSize = (selector) => {
  const [size, setSize] = useState()

  useLayoutEffect(() => {
    const elem = document.querySelector(selector)
    setSize(elem.getBoundingClientRect())

    const resizeObserver = new window.ResizeObserver(() => {
      setSize(elem.getBoundingClientRect())
    });

    resizeObserver.observe(elem);

    return () => {
      resizeObserver.disconnect();
    }
  }, [])

  return size
}

export default useSize